module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b1a1083af6320c24b608246af62ea202.png";